import React, { useEffect, useState } from "react";
import "./App.css";
import ChooseRoom from "./Socket/ChooseRoom";
import Socket from "./Socket/socket";






function App() {




  return (
    <div>


      <Socket />
    </div>
  );
}

export default App;